export const SDK_VERSION = '7.94.1';
